import React from 'react';
import { StyleSheet, Text, View } from '../base_components';
import { BusyComponent } from '../busy_component';

import DialogOverlay from './dialog_overlay';
import EthChainSelect from '../eth/eth_chain_select';
import ImageButton from '../buttons/image_button';
import TextButton from '../buttons/text_button';
import LabelInput from '../forms/label_input';

import CoinStore from '../../stores/coin_store';

import CoinTools from '../../tools/coin_tools';
import EthTools from '../../tools/eth_tools';

const styles = StyleSheet.create({
  coinAddOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerOverlay: {
    width: '29rem',
    paddingTop: '1.2rem',
    paddingBottom: '1.5rem',
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: '1rem',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  title: {
    marginLeft: '1.5rem',
    color: '#333',
    fontSize: '2rem',
    fontWeight: '500',
  },
  closeButton: {
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
    width: '1.2rem',
    height: '1.2rem',
    padding: '0.9rem',
    borderRadius: '0.5rem',
  },
  row: {
    alignSelf: 'stretch',
    flexDirection: 'row',
  },
  rowContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  select: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    marginRight: '1rem',
    flex: 1,
    color: '#333',
    fontSize: '1.4rem',
  },
  nextButton: {
    marginTop: '2rem',
    marginLeft: '1rem',
    marginRight: '1rem',
    alignSelf: 'stretch',
  },
  nextButtonText: {
    color: '#eee',
  },
});

const CLOSE_IMG = require('../../assets/img/close_black.png');

type Props = {
  style?: any;
  onDone: () => void;
};
type State = {
  chain_id: number;
  contract_addr: string;
  amount: string;
  name: string;
  symbol: string;
  decimals: string;
};
export default class CoinAddOverlay extends BusyComponent<Props, State> {
  state = {
    chain_id: 1,
    contract_addr: '',
    name: '',
    symbol: '',
    decimals: '18',
  };
  _onChainChange = (chain_id: string) => {
    this.setState({ chain_id: parseInt(chain_id) });
  };
  _onAddressChange = (contract_addr) => {
    this.setState({ contract_addr }, this._maybeFetch);
  };
  _onNameChange = (name) => this.setState({ name });
  _onSymbolChange = (symbol) => this.setState({ symbol });
  _onDecimalsChange = (decimals) => this.setState({ decimals });
  _maybeFetch = () => {
    const { chain_id, contract_addr } = this.state;
    if (chain_id && contract_addr) {
      _fetchNameSymbol({ chain_id, contract_addr }, (err, result) => {
        if (!err) {
          this.setState(result);
        }
      });
    }
  };
  _onAddPress = () => {
    const { chain_id, contract_addr, name, symbol } = this.state;
    const decimals = parseInt(this.state.decimals);
    if (chain_id && contract_addr && name && symbol && decimals > 0) {
      const opts = {
        chain_id,
        contract_addr,
        name,
        symbol,
        decimals,
      };
      CoinStore.addCoin(opts);
      this.props.onDone();
    }
  };

  render() {
    const { style, onDone } = this.props;
    const { chain_id, contract_addr, name, symbol, decimals } = this.state;

    return (
      <View style={[styles.coinAddOverlay, style]}>
        <DialogOverlay style={styles.innerOverlay} onOutsidePress={onDone}>
          <Text style={styles.title}>Select A Coin</Text>
          <LabelInput text='Blockchain'>
            <EthChainSelect
              style={styles.select}
              value={String(chain_id)}
              onChange={this._onChainChange}
            />
          </LabelInput>
          <LabelInput
            text='Coin Address'
            placeholder='address'
            keyboardType='default'
            maxLength={42}
            autoCapitalize='none'
            value={contract_addr}
            onChangeText={this._onAddressChange}
          />
          <LabelInput
            text='Name'
            placeholder='name'
            keyboardType='default'
            maxLength={64}
            autoCapitalize='none'
            value={name}
            onChangeText={this._onNameChange}
          />
          <View style={styles.row}>
            <View style={styles.rowContainer}>
              <LabelInput
                text='Symbol'
                placeholder='SYM'
                keyboardType='default'
                maxLength={8}
                autoCapitalize='none'
                value={symbol}
                onChangeText={this._onSymbolChange}
              />
            </View>
            <View style={styles.rowContainer}>
              <LabelInput
                text='Decimals'
                placeholder='Decimals'
                keyboardType='number-pad'
                maxLength={8}
                autoCapitalize='none'
                value={decimals}
                onChangeText={this._onDecimalsChange}
              />
            </View>
          </View>
          <TextButton
            style={styles.nextButton}
            type='default'
            text='Add'
            onPress={this._onAddPress}
          />
          <ImageButton
            style={styles.closeButton}
            underlayColor='rgba(0,0,0,0.3)'
            source={CLOSE_IMG}
            onPress={onDone}
          />
        </DialogOverlay>
      </View>
    );
  }
}

const g_fetchCache = {};
function _fetchNameSymbol(params, done) {
  const { chain_id, contract_addr } = params;
  const key = chain_id + '_' + contract_addr;
  const cached = g_fetchCache[key];
  if (cached) {
    done(null, cached);
  } else if (EthTools.isValidAddress(contract_addr)) {
    CoinTools.fetchDetails({ chain_id, contract_addr }, (err, details) => {
      if (err) {
        // noop
      } else if (!details.name) {
        err = 'no_name';
      } else {
        details.decimals = String(details.decimals);
        g_fetchCache[key] = details;
      }
      done(err, details);
    });
  } else {
    done('invalid_address');
  }
}
